import React from "react";
import { IoIosCloseCircle } from "react-icons/io";
import styled from "styled-components";
// Receives an array of objects, each having a state object and a setState function
// and goes through it, setting all fields to undefined

const ButtonWrap = styled.div`
  .ahp-clear-filter-btn {
    /* background-color: light-grey; */
    color: grey;
    padding: "5px 8px";
    font-size: 10px;
    border: none;
    cursor: pointer;
  }

  .ahp-clear-filter-btn:hover {
    background-color: lightgrey;
  }

  .ahp-clear-filter-txt {
    display: inline-block;
  }
`;

function ClearStateBtn({ text, stateAndSetStateArray }) {
  const clearStateFields = (stateAndSetStateArray) => {
    for (const s of stateAndSetStateArray) {
      const stateFields = Object.keys(s.state);
      const blankState = {};
      stateFields.forEach((f) => (blankState[f] = undefined));
      s.setState(blankState);
    }
  };

  return (
    <ButtonWrap>
      <button
        className="ahp-clear-filter-btn"
        onClick={() => clearStateFields(stateAndSetStateArray)}
      >
        <IoIosCloseCircle style={{ size: 10, paddingTop: 3 }} />
        <div className="ahp-clear-filter-txt">{text}</div>
      </button>
    </ButtonWrap>
  );
}

export default ClearStateBtn;
